import { HEADER_AUTHORIZATION } from '../store/actions/api/helpers/headers';

export const authenticatedHeaders = (token: string) => {
  return {
    'Content-Type': 'application/json',
    [HEADER_AUTHORIZATION]: `Bearer ${token}`,
  };
};
